"use strict";

var startCase = require('lodash/startCase');

var getValueOfKeyMatching = require('../getValueOfKeyMatching');

function parse(params, size) {
  var key1 = new RegExp("^".concat(size, "Enclosures|^lp_").concat(size, "Enclosures|REPRINT_[lp_]*").concat(size, "Enclosures"));
  var key2 = 'pers_[lp_]*' + size + 'Enclosures';
  var enclosure_quantity = getValueOfKeyMatching(params, key1);
  var enclosure_personalization = getValueOfKeyMatching(params, key2);

  if (parseInt(enclosure_quantity, 10) > 0) {
    var primaryKey = params.smallEnclosures || params.REPRINT_smallEnclosures || params.COVID_REPRINT_smallEnclosures ? "".concat(size, "Enclosures") : "letterpress".concat(startCase(size), "Enclosures");
    this.personalization.push({
      name: startCase(size) + ' Enclosures',
      value: enclosure_personalization
    });
    this[primaryKey].add({
      quantity: enclosure_quantity
    });
  }
}

function parseEnclosures(params) {
  parse.call(this, params, 'small');
  parse.call(this, params, 'large');
}

module.exports = parseEnclosures;